var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "room-call-new-window-component" },
    [
      _c(
        "div",
        { staticClass: "room-call-new-window", class: { isOpen: _vm.isOpen } },
        [
          _c(
            "transition-group",
            {
              staticClass: "room-call-new-window-transition",
              attrs: { name: "fade" },
            },
            [
              !_vm.isOpen
                ? _c(
                    "div",
                    {
                      key: "open-new-window",
                      staticClass: "room-call-new-window-contents",
                    },
                    [
                      _c("button", {
                        staticClass: "room-call-new-window-button open",
                        on: { click: _vm.onOpen },
                      }),
                      _c(
                        "p",
                        { staticClass: "room-call-new-window-text new-window" },
                        [_vm._v(_vm._s(_vm.$t("call.newWindow.title")))]
                      ),
                    ]
                  )
                : _c(
                    "div",
                    {
                      key: "close-new-window",
                      staticClass: "room-call-new-window-contents",
                    },
                    [
                      _c(
                        "p",
                        { staticClass: "room-call-new-window-text playing" },
                        [_vm._v(_vm._s(_vm.$t("call.newWindow.playing")))]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "room-call-new-window-button close",
                          on: { click: _vm.onClose },
                        },
                        [_vm._v(_vm._s(_vm.$t("call.newWindow.quit")))]
                      ),
                    ]
                  ),
            ]
          ),
        ],
        1
      ),
      _c(
        "RoomWindowOpen",
        {
          ref: "pipVideo",
          attrs: { title: "[Gooroomee-PIP]", width: 640, height: 360 },
          on: { close: _vm.toggle },
        },
        [
          _c("RoomCallMixing", {
            attrs: {
              secondVideo: _vm.isRoomMode(["screenShare"]),
              "video-only": true,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }